import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/my-agreements`;

export async function getAgreementPropertiesAPI() {
  return getRequest(url, await authorize());
}
